import React, { useEffect, useState } from 'react';
import { Users, MessageSquare } from 'lucide-react';
import api from '@/services/api';
import { Team, Feedback } from './AppraisalPage';

/**
 * HR › Staff Appraisals: who has submitted, each submitted appraisal, and the
 * anonymous feedback combined. The server decides what each person may read.
 */
const AppraisalResults = () => {
  const [me, setMe] = useState(null);
  const [tab, setTab] = useState('team');

  useEffect(() => {
    api.get('/appraisals/me').then((r) => setMe(r.data?.data)).catch(() => setMe({ year: new Date().getFullYear() }));
  }, []);

  if (!me) return <div className="flex justify-center py-16"><div className="h-6 w-6 animate-spin rounded-full border-b-2 border-primary-600" /></div>;
  if (!me.canSeeTeam && !me.canSeeFeedback) {
    return <p className="py-16 text-center text-sm text-gray-500">Staff appraisals are only open to HR and management.</p>;
  }

  const tabs = [
    me.canSeeTeam && ['team', 'Staff appraisals', Users],
    me.canSeeFeedback && ['feedback', 'Staff feedback', MessageSquare],
  ].filter(Boolean);
  const current = tabs.find((t) => t[0] === tab) ? tab : tabs[0][0];

  return (
    <div className="mx-auto w-full max-w-5xl space-y-4 pb-16">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Staff appraisals {me.year}</h1>
        <p className="mt-1 text-sm text-gray-500">End-of-year reviews and the anonymous staff feedback.</p>
      </div>
      {tabs.length > 1 && (
        <div className="flex gap-1 overflow-x-auto rounded-lg bg-gray-100 p-1">
          {tabs.map(([k, label, Icon]) => (
            <button key={k} type="button" onClick={() => setTab(k)} className={`inline-flex flex-shrink-0 items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium ${current === k ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'}`}>
              <Icon className="h-4 w-4" />{label}
            </button>
          ))}
        </div>
      )}
      {current === 'team' && <Team />}
      {current === 'feedback' && <Feedback year={me.year} />}
    </div>
  );
};

export default AppraisalResults;
